import actionType from 'utils/mw/actionType.util';

// noinspection JSUnusedGlobalSymbols
export default actionType('VERIFY_CODE');
